import {ProductsProvider} from "../../../../context/products/products-context";
import {StorePageEntryPoint} from "../../../../pages/dashboard/products";
import {useState} from "react";
import {GetStoreServicesOrdersContextProvider} from "../../../../service-feature/useCases/get-orders/context";

export function DashboardHomeStoreSection() {
  const [defaultActiveKey, setDefaultActiveKey] = useState<
    "digital-products" | "services" | "subscriptions"
  >("digital-products");

  function handleTabClick(key: string) {
    if (key === "digital-products") {
      setDefaultActiveKey("digital-products");
    }
    if (key === "services") {
      setDefaultActiveKey("services");
    }
    if (key === "subscriptions") {
      setDefaultActiveKey("subscriptions");
    }
  }
  return (
    <div>
      <ProductsProvider>
        <GetStoreServicesOrdersContextProvider>
          <StorePageEntryPoint
            defaultActiveKey={defaultActiveKey}
            handleTabClick={handleTabClick}
          />
        </GetStoreServicesOrdersContextProvider>
      </ProductsProvider>
    </div>
  );
}
